import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import parse from 'html-react-parser';
import { squareIcons } from 'assets/media/weAre';
import styles from './SquareInformation.module.scss';

// Keyed by stable ids rather than the visible title, so styling survives a
// language change. Ids match pages.weAre.squareInformation in the catalog.
const SQUARES = [
  {
    id: 'education',
    titleClassName: styles.Yellow,
    iconContainerClassName: styles.YellowIconContainer,
  },
  {
    id: 'recovery',
    titleClassName: styles.Green,
    iconContainerClassName: styles.GreenIconContainer,
  },
  {
    id: 'tourism',
    titleClassName: styles.Blue,
    iconContainerClassName: styles.BlueIconContainer,
  },
];

const SquareInformation = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <Row gutter={[40, { xs: 20 }]} justify="space-between" className={styles.Container}>
      {SQUARES.map(({ id, titleClassName, iconContainerClassName }) => {
        const title = t(`pages.weAre.squareInformation.${id}.title`);
        const text = t(`pages.weAre.squareInformation.${id}.text`);

        return (
          <Col md={24} lg={8} key={id}>
            <Row justify="start" gutter={[0, 16]}>
              <Col span={24}>
                <Row gutter={[8, 0]} align="middle">
                  <Col>
                    <div className={iconContainerClassName}>
                      <img src={squareIcons[id]} alt={title} className={styles.Icon} />
                    </div>
                  </Col>
                  <Col>
                    <h2 className={titleClassName}>{title}</h2>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <p className={styles.Text}>{parse(text)}</p>
              </Col>
            </Row>
          </Col>
        );
      })}
    </Row>
  );
};

export default SquareInformation;
